import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { WA_TABS, WhatsAppPage, type WaTab } from '../../../features/B2a/whatsapp-page';

/** D-150: ?channel=<id> picks the number (a WhatsApp channel; unknown / missing -> the main number) */
const search = z.object({ channel: z.string().optional().catch(undefined) });

/** #/whatsapp/<tab> — profile | limits | restrictions | advanced ("connection" is the index route). Lane B2a. */
export const Route = createFileRoute('/_app/whatsapp/$tab')({
  validateSearch: search,
  beforeLoad: ({ params, search: s }) => {
    if (params.tab === 'connection' || !(WA_TABS as readonly string[]).includes(params.tab)) throw redirect({ to: '/whatsapp', search: { channel: s.channel } });
  },
  component: TabPage,
});

function TabPage() {
  const { tab } = Route.useParams();
  const { channel } = Route.useSearch();
  return <WhatsAppPage tab={tab as WaTab} channelId={channel} />;
}
